import {
  useFlag as useRawFlag,
  useUnleashClient,
} from '@unleash/proxy-client-react';
import type {
  FEATURE_AI_GDRIVE_SOURCE,
  FEATURE_DISNEY_GEO_FOOTER,
  FEATURE_WORKFLOW_EMBEDDED_RECIPIENT_SIGNING,
  FEATURE_E_SIGN_CERTIFICATE,
  FEATURE_IMPORT_VIA_FILE,
  FEATURE_PARTNER_API_KEYS,
  FEATURE_STUDIO_COMMENTS,
  FEATURE_TWO_FACTOR_AUTHENTICATION,
  FEATURE_WORKFLOW_CHANGE_ASSESSMENT_STATUS,
  FEATURE_WORKFLOW_DISABLE_DELETE_ACCESS,
  FEATURE_WORKFLOW_ESIGNATURE_EMBEDDED,
  FEATURE_WORKFLOW_VIBEFLOWING,
  INTEGRATIONS_ESIGNATURE_SPLIT,
  INTEGRATIONS_IRONCLAD,
  INTEGRATIONS_IRONCLAD_DEV,
  FEATURE_TICKETING_EXPORT_DATA,
  FEATURE_TICKETING_SUBNAVIGATION,
  FEATURE_TICKETING_AUDIT_PORTAL,
  FEATURE_TOP_LEVEL_REPORTING,
  FEATURE_AI_AGENT_GUIDANCE,
  FEATURE_AI_AGENTIC_LOOP,
  FEATURE_AI_STATUS_GUIDANCE,
  FEATURE_START_BLOCK_EXTRA_FIELDS,
  FEATURE_TICKETING_COLLABORATORS_ENABLED,
  FEATURE_TICKETING_MESSAGE_TIMELINE,
  FEATURE_ESIGN_ACCOUNT_NAME,
  FEATURE_STUDIO_AI_JS_BLOCK,
  FEATURE_WORKFLOW_FORM_MULTISELECT_FIELD,
  FEATURE_ESIGN_SIGNED_DATE_FORMAT,
  FEATURE_ESIGN_REPLACE_RTE,
  FEATURE_TICKETING_TASKS_AND_CALENDAR_EVENTS,
  FEATURE_TICKETING_MATTER_HISTORY,
  FEATURE_TICKETING_UPDATE_TICKET_MESSAGE,
  FEATURE_TICKETING_ONBOARDING_WIZARD,
  FEATURE_FORM_JS_MIDDLEWARE_STATE_RESET,
  FEATURE_STUDIO_CHANGE_ASSESSMENT_STATUS_ENHANCEMENTS,
  FEATURE_TICKETING_REORDER_VIEWS,
  FEATURE_WORKFLOW_DRAG_DROP_FILE_UPLOAD,
  FEATURE_TICKETING_REQUESTER_PORTAL_COLUMN_CONFIG,
  FEATURE_TICKETING_REQUESTER_PORTAL_VISIBILITY,
  FEATURE_AUTH_FRONTEND_CUTOVER,
  LOGIN_SAFE_REDIRECT,
} from './constants';

export interface UnleashContext {
  userId?: string;
  properties?: Record<string, string>;
}

export type Flag =
  | typeof FEATURE_TICKETING_COLLABORATORS_ENABLED
  | typeof FEATURE_IMPORT_VIA_FILE
  | typeof INTEGRATIONS_IRONCLAD
  | typeof FEATURE_WORKFLOW_DISABLE_DELETE_ACCESS
  | typeof FEATURE_STUDIO_COMMENTS
  | typeof FEATURE_DISNEY_GEO_FOOTER
  | typeof INTEGRATIONS_IRONCLAD_DEV
  | typeof FEATURE_WORKFLOW_CHANGE_ASSESSMENT_STATUS
  | typeof FEATURE_WORKFLOW_VIBEFLOWING
  | typeof FEATURE_E_SIGN_CERTIFICATE
  | typeof INTEGRATIONS_ESIGNATURE_SPLIT
  | typeof FEATURE_WORKFLOW_ESIGNATURE_EMBEDDED
  | typeof FEATURE_WORKFLOW_EMBEDDED_RECIPIENT_SIGNING
  | typeof FEATURE_AI_GDRIVE_SOURCE
  | typeof FEATURE_AI_AGENT_GUIDANCE
  | typeof FEATURE_AI_AGENTIC_LOOP
  | typeof FEATURE_AI_STATUS_GUIDANCE
  | typeof FEATURE_TWO_FACTOR_AUTHENTICATION
  | typeof FEATURE_PARTNER_API_KEYS
  | typeof FEATURE_TICKETING_EXPORT_DATA
  | typeof FEATURE_TICKETING_SUBNAVIGATION
  | typeof FEATURE_TICKETING_AUDIT_PORTAL
  | typeof FEATURE_TOP_LEVEL_REPORTING
  | typeof FEATURE_START_BLOCK_EXTRA_FIELDS
  | typeof FEATURE_ESIGN_ACCOUNT_NAME
  | typeof FEATURE_STUDIO_AI_JS_BLOCK
  | typeof FEATURE_ESIGN_SIGNED_DATE_FORMAT
  | typeof FEATURE_ESIGN_REPLACE_RTE
  | typeof FEATURE_TICKETING_TASKS_AND_CALENDAR_EVENTS
  | typeof FEATURE_TICKETING_MATTER_HISTORY
  | typeof FEATURE_TICKETING_UPDATE_TICKET_MESSAGE
  | typeof FEATURE_TICKETING_ONBOARDING_WIZARD
  | typeof FEATURE_WORKFLOW_FORM_MULTISELECT_FIELD
  | typeof FEATURE_FORM_JS_MIDDLEWARE_STATE_RESET
  | typeof FEATURE_STUDIO_CHANGE_ASSESSMENT_STATUS_ENHANCEMENTS
  | typeof FEATURE_TICKETING_MESSAGE_TIMELINE
  | typeof FEATURE_TICKETING_REORDER_VIEWS
  | typeof FEATURE_WORKFLOW_DRAG_DROP_FILE_UPLOAD
  | typeof FEATURE_TICKETING_REQUESTER_PORTAL_COLUMN_CONFIG
  | typeof FEATURE_TICKETING_REQUESTER_PORTAL_VISIBILITY
  // TODO DEV-21196: remove from import + Flag union once cutover complete
  | typeof FEATURE_AUTH_FRONTEND_CUTOVER
  | typeof LOGIN_SAFE_REDIRECT;

/**
  Typed and safe wrapper for unleash useFlag hook that will not throw if the
  flag context is not available.
*/
export const useFlag = (flag: Flag) => {
  try {
    return useRawFlag(flag);
  } catch {
    return false;
  }
};

export const useUnleash = () => {
  const client = useUnleashClient();
  return client;
};
